import { createAction } from '@reduxjs/toolkit';
import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { RecordOf } from 'immutable';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import { HousingSelectionType } from '../housing-selection/housingSelectionTypes';
import type { ZillowSubmittingObject } from './houseStatsTypes';

const getHouseStatsPayloadCreator = getPayloadCreator<string>();
const getHouseStatsSuccessPayloadCreator = getPayloadCreator<RecordOf<QcsSyncResourcesPayload<HousingSelectionType>>>();
const createZillowAccountPayloadCreator = getPayloadCreator<ZillowSubmittingObject>();

export const getHouseData = createAction('GET_HOUSE_DATA', getHouseStatsPayloadCreator);
export const getHouseDataSuccess = createAction('GET_HOUSE_DATA_SUCCESS', getHouseStatsSuccessPayloadCreator);
export const getHouseDataFailure = createAction('GET_HOUSE_DATA_FAILURE');

export const createZillowAccount = createAction('CREATE_ZILLOW_ACCOUNT', createZillowAccountPayloadCreator);
export const createZillowAccountSuccess = createAction('CREATE_ZILLOW_ACCOUNT_SUCCESS');
export const createZillowAccountFIFailure = createAction('CREATE_ZILLOW_ACCOUNT_FAILURE');
